import { DollarSign, Bell, Archive, Video, Settings, Tv } from "react-feather";

const menus = [
  {
    id: 1,
    label: "Programmi",
    url: "/programs",
    Icon: Tv,
  },
  // {
  //   id: 2,
  //   label: "Articoli",
  //   url: "/articles",
  //   Icon: Archive,
  // },
  {
    id: 3,
    label: "Categorie",
    url: "/categories",
    Icon: Archive,
    submenu: [
      {
        id: 3.1,
        label: "Categorie Programmi",
        url: "/program-categories",
      },
      {
        id: 3.2,
        label: "Categorie Episodi",
        url: "/multimedia-categories",
      },
    ],
  },
  {
    id: 4,
    label: "Pubblicità",
    url: "/advertising",
    Icon: DollarSign,
    submenu: [
      {
        id: 4.1,
        label: "Banner",
        url: "/banners",
        // Icon: Archive,
      },
      {
        id: 4.2,
        label: "Pubblicità",
        url: "/advertising-circuit",
        // Icon: Archive,
      },
    ],
  },
  {
    id: 5,
    label: "Media",
    url: "/media",
    Icon: Video,
  },
  {
    id: 6,
    label: "Configurazione",
    url: "/config",
    Icon: Settings,
    submenu: [
      {
        id: 6.1,
        label: "Icone",
        url: "/icons",
      },
      {
        id: 6.2,
        label: "Menù",
        url: "/menu-link",
      },
      {
        id: 6.3,
        label: "Footer",
        url: "/footer",
      },
      {
        id: 6.4,
        label: "Streaming",
        url: "/streaming",
      },
      {
        id: 6.5,
        label: "Firestick app",
        url: "/firestick-app",
      },
    ],
  },
  {
    id: 7,
    label: "Notifiche push",
    url: "/push-notifications",
    Icon: Bell,
  },
];

export default menus;
